import { TrackEventParams } from '@/types/composables';
import { PROD_ORIGIN } from '@/utils/constants/common';
import getSocketId from '@/utils/getSocketId';

export const useGtag = () => {
  const isProd = window.location.origin === PROD_ORIGIN;

  const trackEvent = (eventName: string, params: TrackEventParams) => {
    if (window.gtag && isProd) {
      window.gtag('event', eventName, params);
    }
  };

  const trackEventClick = (page: string, label: string) => {
    trackEvent('button_click', {
      button_location: page,
      button_label: label,
    });
  };

  const trackEventFunnel = (step, param?: object) => {
    trackEvent('subscription_funnel', {
      funnel_step: step,
      ...param,
    });
  };

  const trackEventPurchase = (price: number, currency: string, id?: number) => {
    const param = {
      transaction_id: id ? id.toString() : getSocketId(),
      value: price.toString(),
      currency,
    };

    trackEvent('purchase', param);

    //구글 애즈 - 구매 전환 파악
    trackEvent('conversion', {
      ...param,
      send_to: 'AW-17987002907/MTkQCKPAvoEcEJvE74BD', //TODO: 환경 변수 파일에 추가해야 함
    });
  };

  return {
    trackEventClick,
    trackEventFunnel,
    trackEventPurchase,
  };
};
